module.exports = __webpack_public_path__ + "img/Flag_of_Niger.0c432227.svg";